function getViewportDimensions() {

  return {
    bottom: window.innerHeight,
    height: window.innerHeight,
    left: 0,
    right: window.innerWidth,
    top: 0,
    width: window.innerWidth,
    x: 0,
    y: 0
  };

}

export function normalizeContainer(container) {

  if (container instanceof Node) {
    return container;
  }

  if (container === 'viewport') {
    return {
      getBoundingClientRect: getViewportDimensions
    };
  }

}